import { render } from "./Hint.vue?vue&type=template&id=7869f85a&scoped=true"
const script = {}

import "./Hint.vue?vue&type=style&index=0&id=7869f85a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7869f85a"]])

export default __exports__